<script setup>
import Base from "@/Layouts/Base.vue";
import { Footer, Header } from "@/Components"

defineProps({
  title: {
    type: String,
  },
})

</script>

<template>
  <Base :title="__(':title', { title: title })">
    <div class="flex flex-col relative min-h-full h-screen">
      <Header class="z-5" />
      <div>
        <slot />
      </div>
      <Footer />
    </div>
  </Base>
</template>
